import { RefinancingReasons, ProductPreferences, BankingFeatures, RepaymentOptions } from '@lendi/core-constants';

export {
  BankingFeatures as BANKING_FEATURES,
  ProductPreferences as PRODUCT_PREFERENCES,
  RefinancingReasons as REFINANCING_REASONS,
  RepaymentType as REPAYMENT_TYPE,
  RepaymentTypeDetails as REPAYMENT_TYPE_DETAILS,
  RepaymentOptions as REPAYMENT_OPTIONS,
  BankingFeatures as LENDER_BANKING_FEATURES,
} from '@lendi/core-constants';

export const MIN_LOAN_TERM = 10;
export const MIN_LOAN_TERM_TV = 5;
export const MAX_LOAN_TERM = 30;
export const MAX_LOAN_TERM_TV = 40;

export const GOVERNMENT_RETIREMENT_AGE = 64;

export const REFINANCE_REASON_LABELS = {
  [RefinancingReasons.DecreaseRepayments]: 'Decrease repayments',
  [RefinancingReasons.PayOffLoanFasterWithALowerInterestRate]: 'Pay off loan faster with a lower interest rate',
  [RefinancingReasons.IncreaseLoanAmount]: 'Increase loan amount',
  [RefinancingReasons.ConsolidateDebtAndReduceNumberOfLenders]: 'Consolidate debt and reduce the number of lenders',
  [RefinancingReasons.GreaterFlexibilityOrAdditionalLoanFeatures]: 'Greater flexibility or additional loan features',
  [RefinancingReasons.DissatisfiedWithCurrentLender]: 'Dissatisfied with current lender',
  [RefinancingReasons.CloseToTheEndOfAFixedRateOrInterestOnlyPeriod]:
    'Close to the end of a fixed rate or interest only period',
  [RefinancingReasons.Other]: 'Other',
};

export const REFINANCE_REASON_LABELS_CV = {
  [RefinancingReasons.DecreaseRepayments]: 'Decrease repayments',
  [RefinancingReasons.PayOffLoanFasterWithALowerInterestRate]: 'Pay off loan faster with a lower interest rate',
  [RefinancingReasons.ConsolidateDebtAndReduceNumberOfLenders]: 'Consolidate debt and reduce the number of lenders',
  [RefinancingReasons.IncreaseLoanAmount]: 'Borrow additional funds to get cash out',
  [RefinancingReasons.GreaterFlexibilityOrAdditionalLoanFeatures]: 'Greater flexibility or additional loan features',
  [RefinancingReasons.DissatisfiedWithCurrentLender]: 'Dissatisfied with current lender',
  [RefinancingReasons.CloseToTheEndOfAFixedRateOrInterestOnlyPeriod]:
    'Close to the end of a fixed rate or interest only period',
  [RefinancingReasons.Other]: 'Other',
};

export const RATE_TYPE_LABELS = {
  [ProductPreferences.HaveSetRepayments]: 'Have set repayments',
  [ProductPreferences.TakeAdvantageOfInterestRateDrops]: 'Take advantage of interest rate drops',
  [ProductPreferences.AbilityToPayOffLoanSooner]: 'Ability to pay off my loan sooner',
  [ProductPreferences.HaveABalanceOfCertaintyOfRepaymentsAndFlexibility]:
    'Have a balance of certainty and flexibility in my repayments ',
  [ProductPreferences.AccessFundsSameWayAsRegularBankAccount]:
    'Access the funds the same way I would with a regular bank account',
  [ProductPreferences.AbilityToAccessPrepaidFundsIfNeeded]: 'Ability to access prepaid funds if needed',
  [ProductPreferences.UseSavingsOrSalaryToReduceInterest]: 'Use your savings or salary to reduce interest',
};

export const LENDER_BANKING_FEATURE_LABELS = {
  [BankingFeatures.OpenToEverything]: "I'm open to anything",
  [BankingFeatures.BranchAccess]: 'Branch access',
  [BankingFeatures.FeeFreeAtmTransactions]: 'Fee Free ATM Transactions',
  [BankingFeatures.InternetBanking]: 'Internet Banking',
  [BankingFeatures.MobileApp]: 'Mobile App',
  [BankingFeatures.ApplePay]: 'Apple Pay',
  [BankingFeatures.GooglePay]: 'Google Pay',
  [BankingFeatures.SamsungPay]: 'Samsung Pay',
  [BankingFeatures.CreditCard]: 'Credit card',
  [BankingFeatures.UrgentTurnaround]: 'Urgent turnaround',
};

export const LENDER_BANKING_FEATURE_LABELS_TV = {
  ...LENDER_BANKING_FEATURE_LABELS,
  [BankingFeatures.OpenToEverything]: 'Open to anything',
};

export const REPAYMENT_OPTIONS_LABELS = {
  [RepaymentOptions.WorkPastRetirementAge]: 'Work past retirement age',
  [RepaymentOptions.RepayLoanBeforeRetirement]: 'Repay the loan before retirement',
  [RepaymentOptions.Downsize]: 'Downsize',
  [RepaymentOptions.SellAssets]: 'Sell assets',
  [RepaymentOptions.UseSuperannuationLumpSum]: 'Use superannuation (lump sum)',
  [RepaymentOptions.UseSuperannuationOnGoing]: 'Use superannuation (ongoing)',
  [RepaymentOptions.UseIncomeFromOtherInvestments]: 'Use income from other investments',
  [RepaymentOptions.UseSavings]: 'Use savings',
  [RepaymentOptions.RelyOnCoApplicantsIncome]: "Rely on co-applicant's income",
  [RepaymentOptions.Other]: 'Other',
};

export const REPAYMENT_OPTIONS_LABELS_TV = {
  ...REPAYMENT_OPTIONS_LABELS,
  [RepaymentOptions.WorkPastRetirementAge]: 'Work past Government mandated retirement age',
};
